import React from "react";
import "./style/finalizeStyle.css";
import BasketTable from "./BasketTable";
import { ArrowBackOutline } from "react-ionicons/lib";
import useFinalizeManager from "./hooks/useFinalizeManager";
import useBasketManager from "../SaleMovie/CinemaHall/hooks/useBasketManager";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import { useSelector } from "react-redux";
import { State } from "../../store";
import FinalizeWithLogin from "./FinalizeWithLogin";
import FinalizeNoLogin from "./FinalizeNoLogin";

const colorIcon = "var(--primary-text)";

const FinalizePage: React.FC = () => {
  const { handleBackButton, handleClearBasket, onRemoveItemFromBasket, acceptTransaction, paymentUrl } = useFinalizeManager();
  const { total, basket } = useBasketManager();
  const isDesktop = useDesktopSize();
  const isLogging = useSelector((state: State) => state.auth.isLoggedIn);

  return (
    <div className={`finalize-wrapper ${!isDesktop ? "mobile" : ""}`}>
      <div className={"finalize-button-panel"}>
        <div className={"return-button"} onClick={() => handleClearBasket()}>
          <ArrowBackOutline color={colorIcon} title={""} height="30px" width="30px" />
        </div>
        <div className={"clear-basket-button"} onClick={() => handleClearBasket()}>
          Zacznij od początku
        </div>
      </div>

      <div className={"summary-panel"}>
        <div className={"summary-button-div1"}>
          <div>Do zapłaty: </div>
          <div>{total} zł</div>
        </div>
        <div className={"summary-button-div2"}>
          <input type={"text"} placeholder={"Kod rabatowy"} />
          <button>Dodaj</button>
        </div>
      </div>

      <div className={"basket-panel"}>
        <h3>Twój koszyk</h3>
        <BasketTable basket={basket} onRemoveBasket={onRemoveItemFromBasket} />
      </div>

      <div className={"finalize-panel"}>
        {isLogging ? (
          <FinalizeWithLogin onPayTransaction={acceptTransaction} />
        ) : (
          <FinalizeNoLogin onPayTransaction={acceptTransaction} paymentUrl={paymentUrl} />
        )}
      </div>
    </div>
  );
};

export default FinalizePage;
